function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m243.484375 355.796875h26.03125v26.035156h-26.03125zm0 0",
  fill: "#ea6b65"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m252.152344 60.234375 69.816406-51.539063 36.074219 48.871094-69.8125 51.539063zm0 0",
  fill: "#dc4d41"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m165.382812 147.523438h34.710938v52.070312h-34.710938zm0 0",
  fill: "#f9d7c0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m139.347656 173.558594-34.710937-34.710938-13.765625-48.164062c-2.128906-7.445313-8.933594-12.578125-16.679688-12.582032-9.582031.007813-17.347656 7.785157-17.339844 17.371094 0 1.257813.136719 2.511719.410157 3.742188l12.664062 56.988281 69.421875 60.746094h8.679688v-43.390625zm0 0",
  fill: "#f9d7c0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m226.128906 173.722656 50.46875-8.320312 39.050782-31.398438c6.035156-4.855468 14.558593-5.125 20.890624-.660156 7.824219 5.535156 9.679688 16.367188 4.144532 24.195312-.726563 1.027344-1.566406 1.972657-2.496094 2.820313l-43.253906 39.234375-68.804688 9.542969-8.679687-1.082031v-34.714844zm0 0",
  fill: "#f9d7c0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m355.253906 208.523438c-2.757812.003906-5.355468-1.304688-6.992187-3.523438l-103.042969-139.628906c-2.84375-3.859375-2.023438-9.292969 1.835938-12.136719 3.859374-2.84375 9.289062-2.023437 12.136718 1.835937l103.085938 139.628907c2.839844 3.859375 2.015625 9.292969-1.84375 12.132812-1.476563 1.089844-3.265625 1.679688-5.101563 1.691407zm0 0",
  fill: "#d9d9d9"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  fill: "#fbd699"
}, /*#__PURE__*/React.createElement("path", {
  d: "m391.007812 373.152344h17.355469v17.355468h-17.355469zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m391.007812 338.441406h17.355469v17.355469h-17.355469zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m35.210938 468.609375h17.355468v17.355469h-17.355468zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m35.210938 433.898438h17.355468v17.355468h-17.355468zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m391.007812 286.371094h17.355469v17.359375h-17.355469zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m364.976562 260.339844h17.355469v17.355468h-17.355469zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m391.007812 234.304688h17.355469v17.355468h-17.355469zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m417.042969 260.339844h17.355469v17.355468h-17.355469zm0 0"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m35.210938 381.832031h17.355468v17.355469h-17.355468zm0 0",
  fill: "#f27e55"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m35.210938 347.117188h17.355468v17.359374h-17.355468zm0 0",
  fill: "#fbb540"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m.5 347.117188h17.355469v17.359374h-17.355469zm0 0",
  fill: "#f27e55"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m35.210938 312.40625h17.355468v17.355469h-17.355468zm0 0",
  fill: "#f27e55"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m69.925781 347.117188h17.355469v17.359374h-17.355469zm0 0",
  fill: "#f27e55"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m460.433594 69.421875h17.355468v17.359375h-17.355468zm0 0",
  fill: "#99d8aa"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m434.398438 95.457031h17.355468v17.355469h-17.355468zm0 0",
  fill: "#99d8aa"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m486.464844 95.457031h17.355468v17.355469h-17.355468zm0 0",
  fill: "#99d8aa"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m460.433594 121.492188h17.355468v17.355468h-17.355468zm0 0",
  fill: "#99d8aa"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m87.28125 0h17.355469v17.355469h-17.355469zm0 0",
  fill: "#f27e55"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m69.925781 17.355469h17.355469v17.355469h-17.355469zm0 0",
  fill: "#f27e55"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "m104.636719 17.355469h17.355469v17.355469h-17.355469zm0 0",
  fill: "#f27e55"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m87.28125 34.710938h17.355469v17.355468h-17.355469zm0 0",
  fill: "#f27e55"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "m253.082031 169.472656-26.953125 4.441406v-.355468h-86.78125l-16.394531-16.390625-21.378906 26.726562 37.773437 33.054688v60.746093h86.78125v-68.339843l33.980469-4.71875zm0 0",
  fill: "#fbb540"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "m139.347656 269.015625v130.171875h34.710938v-95.457031h43.390625v34.710937h34.710937v-43.390625c0-14.378906-11.65625-26.035156-26.03125-26.035156zm0 0",
  fill: "#277baa"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "m191.414062 433.898438h-52.066406v-43.390626h34.710938c9.585937 0 17.355468 7.769532 17.355468 17.355469zm0 0",
  fill: "#ea6b65"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "m217.449219 329.761719h34.710937c9.585938 0 17.355469 7.769531 17.355469 17.355469v17.359374h-52.066406zm0 0",
  fill: "#ea6b65"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "m148.027344 86.78125h69.421875v34.710938c0 19.171874-15.539063 34.710937-34.710938 34.710937s-34.714843-15.539063-34.714843-34.710937v-34.710938zm0 0",
  fill: "#f9d7c0"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "m217.449219 104.136719-52.066407-17.355469-17.355468 17.355469v-17.355469c0-19.171875 15.539062-34.714844 34.710937-34.714844s34.710938 15.542969 34.710938 34.714844zm0 0",
  fill: "#834b10"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "m495.144531 512h-130.167969l-52.070312-95.457031h86.78125l27.613281 43.390625h41.808594zm0 0",
  fill: "#428dc5"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "m61.246094 512 52.066406-86.78125h86.78125l43.390625-60.742188h86.777344l34.714843 147.523438zm0 0",
  fill: "#4799cf"
});

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "511pt",
    viewBox: "-4 1 511 511.99993",
    width: "511pt",
    xmlns: "https://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.dc83a58a.svg";
export { ForwardRef as ReactComponent };